var app = app || {};
(function () {
    const loaderPlaceholderId = "loader_placeholder";
    const loaderId = "loader";
    function createLoader() {
        if (!document.getElementById(loaderId)) {
            const loader = `<div id="${loaderId}" class="pageload-overlay" data-opening="m -5,-5 0,70 90,0 0,-70 z m 5,35 c 0,0 15,20 40,0 25,-20 40,0 40,0 l 0,0 C 80,30 65,10 40,30 15,50 0,30 0,30 z"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 80 60" preserveAspectRatio="none"><path d="m -5,-5 0,70 90,0 0,-70 z m 5,5 c 0,0 7.9843788,0 40,0 35,0 40,0 40,0 l 0,60 c 0,0 -3.944487,0 -40,0 -30,0 -40,0 -40,0 z" /></svg></div>`;

            const temp = document.createElement("div");
            temp.innerHTML = loader;

            document.body.prepend(temp.firstChild);
        }
    }

    createLoader();

    var loader = new SVGLoader(document.getElementById(loaderId), { speedIn: 1, speedOut: 400, easingIn: window.mina.easeinout });
    loader.show(function () {
        document.body.removeChild(document.getElementById(loaderPlaceholderId));
    });

    window.Pace.once("hide", function () {
        loader.hide();
    });

    app.showLoader = function (callback) {
        sessionStorage.setItem("pageLoader", true);

        loader.options.speedIn = 400;
        loader.show(function () {
            window.Pace.restart();

            if (callback) {
                setTimeout(callback, 300);
            }
        });
    };
})();
